import { Sites } from '@ps/platform-message-framework/common/Sites';
import { FeatureFlag } from '@ps/web-core-enums';
import { StarsButton, Translation } from '@ps/web-shared-components';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useFeature from '@swf/core/hooks/useFeature';
import { select } from '@swf/core/store';
import type { Dispatch } from '@swf/core/store';
import type { StarsWeb } from '@swf/core/types/Window';

import {
  TXTWCL_CanXt_find_what_youXre_looking_ELL,
  TXTWCL_Contact_Us
} from './ContactUs.messages.json';
import styles from './ContactUs.scss';

const chEmail = 'support@casino777.ch';

const ContactUs: React.FC = () => {
  const { modal } = useDispatch<Dispatch>();
  const isAuthenticated = useSelector(select.session.isAuthenticated);
  const modalState = useSelector(select.modal.getCurrent);
  const shouldOpenSFChat = useSelector(select.help.getShouldOpenSFChat);
  const shouldOpenMessenger = useSelector(select.help.getShouldOpenMessenger);
  const isDesktopEmbedded = useSelector(select.device.isDesktopEmbedded);
  const isMobileEmbedded = useSelector(select.device.isMobileEmbedded);
  const site = useSelector(select.cms.getSiteId);
  const messengerIgnoreLogin = useFeature(FeatureFlag.PSMessengerIgnoreLogin);
  const hidePrompt = useFeature(FeatureFlag.SFHideLoginPrompt);
  const {
    help: { setOpenChat }
  } = useDispatch<Dispatch>();

  useEffect(() => {
    if (modalState === undefined) {
      setOpenChat({ openChat: false });
    }
  }, [modalState, setOpenChat]);

  const openLPMessenger = useCallback(() => {
    if (!isAuthenticated && messengerIgnoreLogin) {
      window.lpTagMgr.openChat();
    } else if (isAuthenticated) {
      window.lpTagMgr.openAuthenticatedChat();
    } else {
      setOpenChat({ openChat: true });
      modal.enqueue({ path: '/help/messenger' });
    }
  }, [isAuthenticated, messengerIgnoreLogin, modal, setOpenChat]);

  const openContactSupportForm = useCallback(() => {
    if (isDesktopEmbedded) {
      const starsweb = window.starsweb as StarsWeb;
      starsweb?.app.execute('support');
    } else if (isMobileEmbedded) {
      const starsweb = window.starsweb as StarsWeb;
      starsweb?.app.execute('support/contact-support');
    } else {
      modal.enqueue({ path: `/help/contact` });
    }
  }, [isDesktopEmbedded, isMobileEmbedded, modal]);

  const openMIAW = useCallback(() => {
    if (!isAuthenticated && messengerIgnoreLogin) {
      window.embeddedservice_bootstrap?.utilAPI.launchChat(true);
    } else if (!isAuthenticated && hidePrompt) {
      window.embeddedservice_bootstrap?.utilAPI.launchChat(true);
    } else if (isAuthenticated) {
      window.embeddedservice_bootstrap?.utilAPI.launchChat(true);
    } else {
      modal.enqueue({ path: '/help/messenger' });
    }
  }, [isAuthenticated, hidePrompt, messengerIgnoreLogin, modal]);

  const handleClick = useCallback(() => {
    if (site === Sites.CH) {
      window.location.href = `mailto:${chEmail}`;
      return;
    }

    if (shouldOpenSFChat) {
      openMIAW();
    } else if (shouldOpenMessenger) {
      openLPMessenger();
    } else {
      openContactSupportForm();
    }
  }, [
    site,
    shouldOpenSFChat,
    shouldOpenMessenger,
    openLPMessenger,
    openContactSupportForm,
    openMIAW
  ]);

  return (
    <section className={styles.container}>
      <h3>
        <Translation {...TXTWCL_CanXt_find_what_youXre_looking_ELL} />
      </h3>
      <StarsButton translation={TXTWCL_Contact_Us} onClick={handleClick} />
    </section>
  );
};

export default ContactUs;
